if (!window.okgContactMapsLoading) {
  window.okgContactMapsLoading = new Promise((resolve, reject) => {
    const configuredMap = document.querySelector('[data-okg-contact-map]');

    if (!configuredMap?.dataset.apiKey || !configuredMap?.dataset.mapId) {
      resolve(null);
      return;
    }

    if (window.google?.maps?.Map) {
      resolve(window.google.maps);
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    window.okgContactMapsCallback = () => resolve(window.google?.maps ?? null);
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(configuredMap.dataset.apiKey)}&libraries=marker&v=weekly&loading=async&callback=okgContactMapsCallback`;
    script.onerror = reject;
    document.head.append(script);
  });
}

async function initializeOkgContactMaps() {
  try {
    const maps = await window.okgContactMapsLoading;
    if (!maps) return;

    document.querySelectorAll('[data-okg-contact-map]').forEach((container) => {
      if (container.dataset.initialized === 'true' || !container.dataset.apiKey || !container.dataset.mapId) return;

      const canvas = container.querySelector('.okg-contact-map__canvas');
      const position = {
        lat: Number(container.dataset.latitude),
        lng: Number(container.dataset.longitude),
      };
      const map = new maps.Map(canvas, {
        center: position,
        fullscreenControl: false,
        mapId: container.dataset.mapId,
        mapTypeControl: false,
        streetViewControl: false,
        zoom: 15,
      });

      if (maps.marker?.AdvancedMarkerElement) {
        new maps.marker.AdvancedMarkerElement({ map, position, title: 'OKG Jewelry' });
      } else {
        new maps.Marker({ map, position, title: 'OKG Jewelry' });
      }
      container.dataset.initialized = 'true';
      maps.event.addListenerOnce(map, 'tilesloaded', () => container.classList.add('is-ready'));
    });
  } catch (error) {
    console.warn('OKG contact map could not load. Showing the embedded map instead.', error);
  }
}

initializeOkgContactMaps();
